import { Service } from 'vue-di-container';
import UserModel from './Model/UserModel';

@Service()
export default class UserRoleService {
    public GetUserRole(user: UserModel): number {
        if (!user || !user.details) {
            return 0;
        }
        const roleName = String(user.details.Role || '').trim();
        const norm = roleName.toLowerCase().replace(/\s+/g, ' ').trim();

        switch (norm) {
            case 'platform admin':
                return 1;
            case 'provider user':
                return 2;
            case 'citc admin':
            case 'cst admin':
            case 'citcadmin':
            case 'cstadmin':
                return 3;
            case 'citc user':
            case 'cst user':
            case 'citcuser':
            case 'cstuser':
                return 4;
            case 'provider admin':
                return 5;
            case 'support':
                return 6;
            case 'finance':
                return 8;
            case 'super admin':
                return 9;
            case 'monitor':
                return 10;
            case 'csttagname':
            case 'cst tag name':
                return 11;
            case 'apiuser 330':
            case 'api330user':
            case 'api user330':
                return 14;
            case 'managing requests':
                return 15;
            case 'fraud management':
                return 16;
            default:
                return 0;
        }
    }
}
